<template>
  <div class="box">
    <admin-box-item title="상품 종류 별 방식 설정"
                    subtitle="상품종류 별로 기본 주문, 문의 전환 및 결제방식을 설정할 수 있습니다">
      <!-- 팩 종류 -->
      <div v-for="pack in packageSettings" :key="'package-'+pack.id"
           class="pack-box"
           @click="setPackageSetting(pack)"
           :class="{'package-selected':pack.package===selectedPackage.package}">{{ pack.kor_name }}</div>

      <admin-form-item style="margin-top:20px;margin-left:8px"
                       label="기본 상품 문의 전환" desc="문의 받고 싶은 유형을 선택합니다."
                       tip="유저가 상품을 보고 상품 제공자에게 어떻게 문의하도록 할 것인지하는 기본 문의 방식을 선택할 수 있습니다.">
        <lp-radio :val.sync="selectedPackage.inquiry_conversion_type"
                  value_name="value"
                  label_name="label"
                  :data="inquiry_conversion_arr"></lp-radio>
      </admin-form-item>

      <admin-form-item style="margin-top:28px;margin-left:8px"
                       label="기본 상품 주문 전환" desc="주문 받고 싶은 유형을 선택합니다."
                       tip="유저가 상품을 보고 어떻게 주문하도록 할 것인지하는 기본 주문 방식표시됩니다.">
        <lp-radio :val.sync="selectedPackage.order_conversion_type"
                  value_name="value"
                  label_name="label"
                  :data="order_conversion_arr"></lp-radio>
      </admin-form-item>

      <admin-form-item style="margin-top: 28px; margin-left: 8px;"
                       label="결제방식"
                       v-if="showPayTypeSetting" tip="사용 중인 서비스팩 종류에 따라 표시되는 항목은 상이할 수 있습니다. ">
        <lp-radio :val.sync="selectedPackage.payment_type"
                  value_name="value"
                  label_name="label"
                  :data="paymentTypeArr"></lp-radio>
      </admin-form-item>

      <div style="margin-top:20px;width:100%" class="columns is-multiline">
        <div class="column is-6-desktop" style="margin-bottom:12px"
             v-for="(autoSetting, idx) in autoSettings" :key="'auto-setting-'+idx">
          <!-- 자동 배송완료 -->
          <div class="column is-full">
            <admin-form-item :label="'자동 ' + autoSetting.label">
              <lp-radio :val="selectedPackage.auto_status[autoSetting.value]"
                        @onSelect="res=> selectedPackage.auto_status[autoSetting.value] = res"
                        value_name="value"
                        label_name="label"
                        :data="autoSetting.options"></lp-radio>
            </admin-form-item>
          </div>
          <div class="column is-full" v-if="selectedPackage.auto_status[autoSetting.value]">
            <admin-form-item>
              <div class="flex-align">
                <input class="input"
                       style="width:40px"
                       v-model="selectedPackage.auto_status[autoSetting.value+'_day']"
                       @input="e=>setNumber(e, autoSetting.value+'_day', 3)"
                       type="number">
                <div style="margin-left:4px">일 후 자동 상태 변경</div>
              </div>
            </admin-form-item>
          </div>
        </div>
      </div>
    </admin-box-item>
  </div>
</template>
<script>
  import LpRadio from "../../module/common/LpRadio";
  export default {
    name: "ProductPackageSetting",
    components: {LpRadio},
    props: {
      packages: {

      }
    },
    created() {
      this.$axios.get(this.getUrl('order/setting')).then(res=>{
        this.orderSetting = res.data;
        this.pay_type = [];
        this.orderSetting.paylist.forEach(item=>{
          for(let i=0; i<item.pay_type.length; i++) {
            let pay_type = item.pay_type;

            if(pay_type[i].name==='kakaopay') {
              let social_key = this.$store.getters.backendData.social_key;
              if (social_key && social_key.kakao.admin_key && social_key.kakao.cid) {
                // this.pay_type = this.pay_type.concat(item.pay_type);
                this.pay_type.push(item.pay_type[i]);
              }
            } else {
              this.pay_type.push(item.pay_type[i]);
              // this.pay_type = this.pay_type.concat(item.pay_type);
              // break;
            }
          }
        });
      });

      // PackageSetting 호출 (상품종류 별 주문전환,문의전환,결제방식,자동처리 설정)
      this.$axios.get('admin/service/package_setting/init').then(() => {
        this.$axios.get('admin/service/package_setting?ordering=order_conversion_type').then(res => {
          res.data.forEach(item => {
            item.kor_name = this.packages.filter(pack=>{ return pack.name === item.package })[0].kor_name;
          });
          this.packageSettings = res.data;
          this.setPackageSetting(res.data[0]);    // 첫번째 팩 기본 선택
        });
      });
      // 기본 상품 종류 불러오기
      this.$axios.get('admin/service/setting')
        .then(res => {
          if (res.status === 200) {
            this.basic_package = res.data.basic_package;
          }
        });
    },
    data() {
      return {
        orderSetting: {
          pay_type: [],
          bank: {
            name: '',
            bank: '',
            account_num: ''
          }
        },

        pay_type: [],
        selectedPackage: '',
        packageSettings: [],
        // 문의 전환
        inquiry_conversion_arr: [
          {label: '없음', value: 0},
          {label: '전화문의', value: 1},
          {label: '이메일문의', value: 2},
          {label: '톡문의', value: 3},
        ],
        // 주문 전환
        order_conversion_arr: [],
        // 자동 처리 설정 목록
        autoSettings: [],
      }
    },
    computed: {
      showPayTypeSetting() {
        return [0,1,2,4,5,6,7,9].indexOf(this.selectedPackage.order_conversion_type) === -1;
      },
      paymentTypeArr() {
        let list = [{label:'결제 없음',value:0},{label:'결제있음',value:1},{label:'현장결제',value:2}];
        return list.slice(0, this.selectedPackage.able_payment_type+1);
      }
    },
    methods: {
      async save() {
        // 상품 종류별 업데이트
        for(let pack of this.packageSettings) {
          await this.$axios.patch(`admin/service/package_setting/${pack.package}`, pack);
        }
      },
      setNumber(e, type, max_length){
        if( e.target.value.length > max_length ) this.selectedPackage.auto_status[type] = e.target.value.substr(0,max_length);
        else this.selectedPackage.auto_status[type] = e.target.value;
      },
      setPackageSetting(pack) {
        this.selectedPackage = pack;
        this.changeConversionList();
        this.autoSettings = [
          {
            label: '결제취소',
            value: 'cancel_paid',
            options:[
              { label: '미입금 -> 결제취소', value: true },
              { label: '사용안함', value: false }
            ]
          }
        ];

        // 자동처리 설정 사용 안하는 상품 종류(전화연결, 아웃링크, 견적요청)
        if(['call','outlink','estimate'].indexOf(pack.package)>-1) {
          this.autoSettings = [];
        }
        // booking, reservation 팩인 경우, 자동 이용완료 처리 옵션값 반영
        else if (['booking', 'reservation'].indexOf(pack.package)>-1) {
          this.autoSettings = this.autoSettings.concat([
            {
              label: '상태 변경',
              value: 'success_purchase',
              options: [
                {label: '이용 예정 -> 이용 완료', value: true},
                {label: '사용안함', value: false}
              ]
            }
          ])
        }
        // 자동처리 중 구매확정/배송완료/배송지연 필요한 상품 종류(예약배달, 배송주문)
        else if(['mart','delivery'].indexOf(pack.package)>-1) {
          this.autoSettings = this.autoSettings.concat([
            {
              label: '구매확정',
              value: 'success_order',
              options: [
                {label: '배송완료 -> 구매확정', value: true},
                {label: '사용안함', value: false}
              ]
            },
            {
              label: '배송완료',
              value: 'success_delivery',
              options: [
                {label: '배송중 -> 배송완료', value: true},
                {label: '사용안함', value: false}
              ]
            },
            {
              label: '배송지연',
              value: 'delay_delivery',
              options: [
                {label: '상품준비중 -> 구매확정', value: true},
                {label: '사용안함', value: false}
              ]
            }
          ]);
        }
      },
      changeConversionList() {
        // 선택된 상품 종류에 해당하는 주문전환 목록 생성
        let pack = find(this.packages, 'name', this.selectedPackage.package);
        this.order_conversion_arr = [
          {label: '없음', value: 0},
          {label: pack.kor_name, value: pack.id},
        ];
      },
    }
  }
</script>
<style lang="stylus" scoped>
  @import '~assets/css/lp_main'
  .pack-box
    border 1px solid #787878
    color #787878
    display inline-block
    padding 4px 16px
    border-radius 3px
    margin 4px
    font-size 14px
    cursor pointer

  .package-selected
    color $primary
    border 1px solid $primary
</style>
